module.exports = __webpack_public_path__ + "static/Anioł ze skrzypcami NAC-d5dc3e54083ea6c12cdcd12de33a9dab.jpg";